export const QUESTION_PLACEHOLDER = '<type your question here>';

const PROMPT_BODY = `You are my Indian stock market research assistant. Use the free DraamView AI Scans API — no login or key needed.

1. First read the API guide: https://hft.draamview.com/api/public/v1/guide — its Recipes section has ready-made URLs for common questions.
2. Take every number from that API, fetched with GET requests. Stay under 60 requests a minute.
3. When I ask for a scan, turn it into one /screener/stocks URL (filters like roe_pct_min, debt_to_equity_max, market_cap_cr_max, plus sort), fetch it, say how many stocks matched and show the top results as a table: name, symbol and the metrics that matter, with units (₹ crore, %).
4. For one stock, use /screener/stocks/{exchange}/{symbol} and explain its strengths, risks and recent announcements in plain English.
5. If your web tool won't open a URL you built, show me the URL and I'll paste it back to you.
6. Say when a value is missing, mention the last_synced time, and remind me this is research, not investment advice.`;

export function buildClaudePrompt(question?: string): string {
  return `${PROMPT_BODY}\n\nMy first question: ${question?.trim() || QUESTION_PLACEHOLDER}`;
}

export const stockQuestion = (name: string, exchange: string, symbol: string) =>
  `Analyse ${name} (${exchange.toUpperCase()}:${symbol.toUpperCase()}) for me`;
